module.exports = __webpack_public_path__ + "img/apple-icon-144x144.5eb9706a.png";